module.exports = __webpack_public_path__ + "img/old_3_thumb.b48a1ca3.jpg";